<template>
  <ModalDialog
    :open="true"
    :headerText="headerText || 'Confirmation'"
    @closeModal="closeModal(false)"
    class="confirmation-modal"
  >
    <template #content>
      <p class="content-text" data-cy="content-text">
        {{ text || "Confirm action?" }}
      </p>
      <div class="button-group">
        <Button type="button" theme-color="primary" @click="closeModal(true)">
          Confirm
        </Button>
        <Button
          type="button"
          theme-color="secondary"
          @click="closeModal(false)"
        >
          Cancel
        </Button>
      </div>
    </template>
  </ModalDialog>
</template>

<script setup lang="ts">
import { Button } from "@progress/kendo-vue-buttons";
import ModalDialog from "./ModalDialog.vue";

defineProps<{
  headerText?: string;
  text?: string;
}>();

const emit = defineEmits<{
  (e: "closeModal", confirmed: boolean): void;
}>();

const closeModal = (confirmed: boolean) => {
  emit("closeModal", confirmed);
};
</script>

<style lang="scss">
.confirmation-modal {
  .modal-content {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    flex-direction: column;
    align-content: center;

    .content-text {
      text-align: justify;
      font-size: 1rem;
      padding: 24px;
    }

    .button-group {
      display: flex;
      gap: 16px;
      justify-content: center;
      margin-bottom: 12px;
    }
  }
}
</style>
